var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icon / Unfilled / star-empty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.8172 5.08844C12.0018 4.6448 12.6302 4.6448 12.8147 5.08844L14.7611 9.76805C14.8389 9.95507 15.0148 10.0829 15.2167 10.0991L20.2687 10.5041C20.7477 10.5425 20.9419 11.1402 20.577 11.4528L16.7279 14.7499C16.574 14.8817 16.5068 15.0885 16.5538 15.2855L17.7298 20.2154C17.8413 20.6828 17.3328 21.0522 16.9228 20.8018L12.5976 18.1599C12.4247 18.0543 12.2073 18.0543 12.0344 18.1599L7.70918 20.8018C7.29913 21.0522 6.79068 20.6828 6.90217 20.2154L8.07814 15.2855C8.12514 15.0885 8.05795 14.8817 7.90412 14.7499L4.055 11.4528C3.69009 11.1402 3.8843 10.5425 4.36325 10.5041L9.41528 10.0991C9.61719 10.0829 9.79308 9.95507 9.87087 9.76805L11.8172 5.08844Z",
    stroke: "#6D7699"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.d5cb7594381afa5fb80ed326d986da15.svg";
export { ForwardRef as ReactComponent };